import type { ClassValue } from 'clsx'
// eslint-disable-next-line no-restricted-imports
import { clsx } from 'clsx'
// eslint-disable-next-line no-restricted-imports
import { twMerge as tailwindMerge } from 'tailwind-merge'

/**
 * Merges Tailwind classes together.
 *
 * @param {ClassValue[]} inputs - The classes to merge.
 *
 * @returns {string}
 */
export function twMerge(...inputs: ClassValue[]): string {
  return tailwindMerge(clsx(inputs))
}
